module.exports = __webpack_public_path__ + "img/whos.fc8ff69e.jpg";